import {Stringifier} from '../../services/stringifier.service';
import {BaseFilterRequest} from './base-filter-request';
import {FInt} from '../../services/filters/int-filter';
import {FString} from '../../services/filters/string-filter';
import {FBoolean} from '../../services/filters/boolean-filter';
import {FDate} from '../../services/filters/date-filter';

@Stringifier
export class FilterMediaSourceRequest extends BaseFilterRequest {
  mediaSourceId?: FInt;
  name?: FString;
  description?: FString;
  category?: FString;
  showDeleted?: boolean;
  genericText?: string;
  mediaSourceType?: FInt;
  sequentialRequestId: number = 0;

    static getStringifier(level: number): FilterMediaSourceRequest | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            mediaSourceId: null,
            name: null,
            description: null,
            category: null,
            showDeleted: null,
            genericText: null,
            mediaSourceType: null,
            sequentialRequestId: null,
        } as FilterMediaSourceRequest;
    }
}
